import type { KeyStatSurveyItem } from '../../../../models/Report'
import { KeyStatType } from '../constants'
import { isNotApplicableOption } from '../questionSampleSize'

export interface ModeChartDisplayData {
  optionLabels: string[]
  values: Array<number | string | null>
}

export const getModeChartDisplayData = (report: KeyStatSurveyItem): ModeChartDisplayData => {
  const optionEntries = (report.options ?? [])
    .map((option, index) => ({ option, index }))
    .filter(({ option }) => !isNotApplicableOption(option, report.itemType))

  const modeCalc = report.calculations?.find((calc) => calc.name === KeyStatType.MODE)
  const rawModeValues = modeCalc?.values
  const modeValues = Array.isArray(rawModeValues) ? rawModeValues : []

  return {
    optionLabels: optionEntries.map(({ option }) => option.name),
    values: optionEntries.map(({ index }) => modeValues[index] ?? null)
  }
}
